<template>  
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true"  >  
        <div class="modal-dialog" style="max-width:1700px;">  
            <div class="modal-content"  style="min-height: 450px;">  
                <div class="modal-header"> 
					<h2>Relatório Instrutor</h2> 
					<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" >
						<span class="svg-icon svg-icon-1">
							<inline-svg src="media/icons/duotone/Navigation/Close.svg" />
						</span>
					</div> 
				</div> 
				<div class="modal-body scroll-y " :key="identificador" >
                    <CardRh >  
                        <div class="col-12 col-md-12  min-h-1850px"> 
                            <iframe :src="url" width="100%" height="700px"   style="border: none;"></iframe>   
                        </div>   
                    </CardRh> 
				</div>   
			</div> 
		</div> 
	</div> 
</template>

<script lang="ts">  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import InstrutorService from   "@/service/v1/sigap/InstrutorService"   
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "InstrutorPdf",
        components: {  CardRh  },   
    }) 
    export default class InstrutorPdf extends Vue {  
        
        @authStore.Getter
		public token!: any 

        @Prop( ) readonly dados!: any   
        @Prop( ) readonly ano!: any   
        @Prop( ) readonly mes!: any   
        @Prop( ) readonly disciplina!: any   
        @Prop( ) readonly turmaId!: any   
        @Prop( ) readonly modal!: any  
        
        public service = new InstrutorService();
        public identificador = 1 ;   
        public url: any = ""; 

        @Watch('dados')
		dadosAtualizado(newVal: string) {  
            this.gerarRelatorio();
		} 
  
        public gerarRelatorio(){
            this.url =   null; 
            if(this.dados != null ){
                setTimeout(() => {
                this.url =  `${this.service.getApiUrl()}/Relatorio/Aula/Pdf2?instrutorAuxiliarCPF=${this.dados.id}&ano=${this.ano ??'' }&mes=${ this.mes ??'' }&disciplina=${this.disciplina??'' }&turmaId=${this.turmaId??'' }&token=${ this.token}` ;
                this.identificador++;
            }, 2 ); 
            } 
            
        }
    } 
</script> 


<style scoped>  
    .btn-flex-full{
        max-width: 100%;
        min-width: 100%;
    } 
    .start-90{
        left: 97% !important;
    }
</style>